<template>
  <div class="page-clue">
    <crm-panel :title="'销售线索'">
      <!-- 操作按钮 -->
      <div class="page-buttons">
        <crm-button
          v-if="auth.cluesAdd && auth.cluesAdd.toggleStatus"
          :buttonType="'secondary'"
          :text="'新增'"
          @click="toAddClue()"
        >
        </crm-button>
        <crm-button
          v-if="auth.cluesExport && auth.cluesExport.toggleStatus"
          :buttonType="'plain'"
          :text="'导出'"
          @click="handleExport()"
        >
        </crm-button>
      </div>
      <!-- 搜索条 -->
      <div class="mt20">
        <el-form ref="form" :inline="true" :model="search">
          <el-form-item label="">
            <el-select
              clearable
              v-model="search.cluesStatus"
              @change="handleSearch()"
              placeholder="状态"
            >
              <el-option
                v-for="item in clueStatus"
                :label="item.label"
                :value="item.value"
                :key="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-date-picker
              value-format="yyyy-MM-dd"
              :editable="false"
              v-model="search.time"
              @change="handleSearch()"
              type="daterange"
              range-separator="至"
              start-placeholder="创建日期始"
              end-placeholder="创建日期止"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="">
            <el-input
              placeholder="根据名称查询"
              v-model="search.input"
              class="input-with-select"
            >
              <el-select v-model="search.type" slot="prepend">
                <el-option
                  v-for="item in searchType"
                  :label="item.label"
                  :value="item.value"
                  :key="item.value"
                >
                </el-option>
              </el-select>
              <i
                slot="suffix"
                class="el-input__icon el-icon-search"
                @click="handleSearch"
                style="cursor: pointer"
              ></i>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <el-table
        :data="clueListData && clueListData.results"
        border
        v-loading="loading"
        fit
        height="100%"
        style="width: 100%"
      >
        <el-table-column
          show-overflow-tooltip
          label="姓名"
          align="center"
        >
          <template slot-scope="{ row }">
            <span
              class="link"
              @click="toDetail(row)"
              v-if="auth.cluesDetailTab && auth.cluesDetailTab.toggleStatus"
            >
              {{ row.name }}
            </span>
            <span v-else>
              {{ row.name }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="companyName"
          width="200"
          label="公司"
          align="center"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="cluesSourceName"
          align="center"
          width="100"
          label="来源"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="intention"
          align="center"
          label="意向"
        >
        </el-table-column>
        <el-table-column
          prop="cluesStatus"
          width="70"
          align="center"
          label="状态"
        >
          <template slot-scope="{ row }">
            {{ row.cluesStatus | statusFilter }}
          </template>
        </el-table-column>
        <el-table-column
          prop="salesmanName"
          align="center"
          width="80"
          label="业务员"
        >
        </el-table-column>
        <el-table-column width="160" align="center" label="操作">
          <template slot-scope="{ row }">
            <el-button
              v-if="visitAuth.visitAdd && visitAuth.visitAdd.toggleStatus"
              @click="toVisit(row)"
              type="text"
              size="small"
            >
              拜访
            </el-button>
            <el-button
              v-if="
                auth.cluesUpdateSalesman &&
                  auth.cluesUpdateSalesman.toggleStatus
              "
              @click="toChangeSalesman(row)"
              type="text"
              size="small"
            >
              替换业务员
            </el-button>
            <el-button
              v-if="
                auth.cluesUpdate &&
                  auth.cluesUpdate.toggleStatus &&
                  row.salesmanCode === userInfo.userUid
              "
              @click="toEditClue(row)"
              type="text"
              size="small"
            >
              编辑
            </el-button>
            <el-button
              v-if="auth.cluesDelete && auth.cluesDelete.toggleStatus"
              @click="delClue(row)"
              type="text"
              size="small"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 客户列表分页 -->
      <div class="pageination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="pagenation.pageNumber"
          :page-sizes="[10, 20, 50, 100, 200]"
          :page-size="pagenation.pageSize"
          layout="total, sizes, prev, pager, next"
          :total="(clueListData && clueListData.totalCount) || 0"
        >
        </el-pagination>
      </div>
    </crm-panel>

    <el-dialog
      title="替换业务员"
      :visible.sync="salesmanVisible"
      width="40%"
      @close="salesmanVisible = false"
    >
      <el-form :model="salesmanForm" ref="salesmanForm" label-width="100px">
        <el-form-item label="当前业务员:" prop="now">
          {{ salesmanForm.now }}
        </el-form-item>
        <el-form-item
          label="替换后业务员:"
          prop="code"
          :rules="{
            required: true,
            message: '请选择替换后业务员',
            trigger: 'change',
          }"
        >
          <el-select
            filterable
            v-model="salesmanForm.code"
            placeholder="请选择"
          >
            <el-option
              v-for="item in allSalesman"
              :label="`${item.userName} - ${item.loginId}`"
              :value="item.code"
              :key="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="salesmanVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSaveSalesmanChange"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <add
      :visible="addVisible"
      @close="addVisible = false"
      @success="handleSearch()"
    ></add>
    <edit
      :visible="editVisible"
      :detail="editDetail"
      @close="editVisible = false"
      @success="handleGetListData()"
    >
    </edit>
    <detail
      v-if="detailVisible"
      :id="detailId"
      @close="detailVisible = false"
      @refresh="handleGetListData()"
    ></detail>

    <!-- 新增 -->
    <add-visit
      v-if="isAddVisitVisible"
      :visible="isAddVisitVisible"
      :detail="visitDetail"
      @close="isAddVisitVisible = false"
    >
    </add-visit>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { downloadByUrl } from '@/scripts/utils';
import CrmPanel from '@/components/base/crmPanel';
import CrmButton from '@/components/base/crmButton';
import Add from '@/components/business/clue/add';
import Edit from '@/components/business/clue/edit';
import Detail from '@/components/business/clue/detail';
import AddVisit from '@/components/business/visit/addVisit';

export default {
  components: {
    CrmPanel,
    CrmButton,
    Add,
    Edit,
    Detail,
    AddVisit,
  },
  filters: {
    statusFilter(val) {
      const list = [
        {
          label: '待处理',
          value: 0,
        },
        {
          label: '跟进中',
          value: 1,
        },
        {
          label: '已转换',
          value: 2,
        },
        {
          label: '失效',
          value: 3,
        },
        {
          label: '其他',
          value: 4,
        },
      ];
      return list.find(item => item.value === val).label;
    },
  },
  data() {
    return {
      loading: false,
      isAddVisitVisible: false,
      search: {
        cluesStatus: null,
        time: [],
        type: 'name',
        input: null,
      },
      pagenation: {
        pageSize: 10,
        pageNumber: 1,
      },
      clueStatus: [
        {
          label: '待处理',
          value: 0,
        },
        {
          label: '跟进中',
          value: 1,
        },
        {
          label: '已转换',
          value: 2,
        },
        {
          label: '失效',
          value: 3,
        },
      ],
      searchType: [
        {
          label: '姓名',
          value: 'name',
        },
        {
          label: '公司名称',
          value: 'companyName',
        },
        {
          label: '业务员',
          value: 'salesmanName',
        },
        {
          label: '创建人',
          value: 'createdName',
        },
      ],
      salesmanVisible: false,
      salesmanForm: {
        code: null,
        now: null,
        id: null,
      },
      addVisible: false,
      editVisible: false,
      editDetail: {},
      detailVisible: false,
      detailId: null,
      clueDetail: {},
    };
  },
  computed: {
    ...mapGetters({
      auth: 'authority/auth',
      visitAuth: 'authority/visitAuth',
      clueListData: 'clue/clueListData',
      allSalesman: 'clue/allSalesman',
      userInfo: 'authority/userInfo',
    }),
  },
  async mounted() {
    await this.getAuthority({ menuUrl: '/visit' });
    console.log(this.visitAuth, 'visitAuth');
  },
  methods: {
    ...mapActions({
      getClueData: 'clue/getClueData',
      deleteClue: 'clue/deleteClue',
      getAllSalesman: 'clue/getAllSalesman',
      saveSalesmanChange: 'clue/saveSalesmanChange',
      getAuthority: 'authority/getAuthority',
    }),
    // 新增
    handleAddVisit() {
      this.isAddVisitVisible = true;
    },
    handleSearch() {
      this.pagenation.pageNumber = 1;
      this.handleGetListData();
    },
    handleGetListData() {
      this.loading = true;
      this.getClueData({
        ...this.handleParams(),
        ...this.pagenation,
      }).finally(() => {
        this.loading = false;
      });
    },
    handleParams() {
      this.search.name = null;
      this.search.companyName = null;
      this.search.salesmanName = null;
      this.search.createdName = null;
      if (this.search.type) this.search[this.search.type] = this.search.input;
      this.search.startDateStr = this.search.time ? this.search.time[0] : null;
      this.search.endDateStr = this.search.time ? this.search.time[1] : null;
      const {
        time, input, type, ...otherParams 
      } = this.search;
      return otherParams;
    },
    handleExport() {
      const notify = this.$notify.info('正在导出中……');
      const params = this.handleParams();
      let url = '/api/clues/export?';
      Object.keys(params).forEach((item) => {
        if (params[item]) url += `${item}=${params[item]}&`;
      });
      downloadByUrl(url);
      notify.close();
    },
    delClue(row) {
      this.$confirm('此操作将永久删除该线索, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.deleteClue({ id: row.id })
            .then(() => {
              this.handleGetListData();
              this.$message({
                type: 'success',
                message: '删除成功!',
              });
            })
            .catch(() => {});
        })
        .catch(() => {});
    },
    toAddClue() {
      this.addVisible = true;
    },
    toDetail(row) {
      this.detailId = row.id;
      this.detailVisible = true;
    },
    toEditClue(row) {
      this.editDetail = row;
      this.editVisible = true;
    },
    toChangeSalesman(row) {
      if (!this.allSalesman.length) this.getAllSalesman();
      this.salesmanForm.id = row.id;
      this.salesmanForm.now = row.salesmanName;
      this.salesmanVisible = true;
    },
    handleSaveSalesmanChange() {
      const { now, ...otherParams } = this.salesmanForm;
      this.saveSalesmanChange(otherParams)
        .then(() => {
          this.salesmanVisible = false;
          this.$message.success('替换成功！');
          this.handleGetListData();
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.pagenation.pageSize = val;
      this.pagenation.pageNumber = 1;
      this.handleGetListData();
    },
    handleCurrentChange(val) {
      this.pagenation.pageNumber = val;
      this.handleGetListData();
    },
    // 拜访
    toVisit(row) {
      this.visitDetail = {
        visitObject: 3,
        visitObjectId: row.id,
        cluesName: row.name,
        cluesId: row.id,
        salesmanCode: this.userInfo.userUid,
        cluesVisible: false,
        customVisible: false,
        contactVisible: false,
        buisVisible: false,
        canEdit: false,
      };
      this.isAddVisitVisible = true;
      console.log(this.visitDetail, 'this.visitDetail');
    },
  },
  created() {
    this.handleSearch();
    console.log(this.auth);
  },
};
</script>

<style lang="less">
@import '~@/styles/const.less';

.page-clue {
  display: flex;
  flex: 1;
  width: 100%;
}
</style>
